const roundToHundredths = (value) => Math.round(value * 100) / 100;

const getHeroScrollState = (
  scrollTop,
  collapseDistance,
  collapseMaxProgress = 1,
) => {
  const safeScrollTop = Math.max(Number(scrollTop) || 0, 0);
  const safeCollapseDistance = Math.max(Number(collapseDistance) || 0, 0);
  const safeCollapseMaxProgress = Math.max(Number(collapseMaxProgress) || 0, 0);

  if (safeCollapseDistance === 0) {
    return {
      heroCollapseProgress: safeCollapseMaxProgress,
      heroVisualProgress: safeCollapseMaxProgress > 0 ? 1 : 0,
      lockedContentOffset: 0,
    };
  }

  const lockedContentOffset = Math.min(safeScrollTop, safeCollapseDistance);
  const heroVisualProgress = lockedContentOffset / safeCollapseDistance;
  const heroCollapseProgress = heroVisualProgress * safeCollapseMaxProgress;

  return {
    heroCollapseProgress: roundToHundredths(heroCollapseProgress),
    heroVisualProgress: roundToHundredths(heroVisualProgress),
    lockedContentOffset: roundToHundredths(lockedContentOffset),
  };
};

export const getHeroSnapTarget = (
  scrollTop,
  collapseDistance,
  scrollDelta = 0,
) => {
  const safeScrollTop = Math.max(Number(scrollTop) || 0, 0);
  const safeCollapseDistance = Math.max(Number(collapseDistance) || 0, 0);
  const safeScrollDelta = Number(scrollDelta) || 0;

  if (safeCollapseDistance <= 0) {
    return null;
  }

  const isInTransitionZone = safeScrollTop > 0
    && safeScrollTop < safeCollapseDistance;
  if (!isInTransitionZone) {
    return null;
  }

  if (safeScrollDelta > 0) {
    return safeCollapseDistance;
  }
  if (safeScrollDelta < 0) {
    return 0;
  }

  return safeScrollTop >= (safeCollapseDistance / 2)
    ? safeCollapseDistance
    : 0;
};

export default getHeroScrollState;
